import classnames from 'classnames';

import { DropdownMenuPosition } from 'ui-components/components/INTERNAL/dropdown/dropdown-menu-position';

import style from './ship-date.module.less';
import { UiRestrictions } from '../../../../../enums/component-states';
import { useIsLocalDeliveryServiceSelected } from '../../../../../fulfillment-planner/hooks/use-is-local-delivery-service-selected';
import ShipDateComponent from '../../../../../fulfillment-planner/ship-date';
import { useHasFulfillmentPlanRestriction } from '../../../fulfillment-plan/restrictions-context';
import messages from '../../../fulfillment-plan/sections/configure-shipment/messages';

/**
 * @param {object} props
 * @param {string} props.dropdownIconClassName
 * @param {string} props.linkButtonClassName
 * @returns {false|JSX.Element}
 */
const ShipDate = ({ dropdownIconClassName, linkButtonClassName }) => {
  const isLocalDelivery = useIsLocalDeliveryServiceSelected();

  const isRestricted = useHasFulfillmentPlanRestriction(UiRestrictions.LabelConfiguration);

  const hideShipDate = isLocalDelivery || isRestricted;

  return (
    !hideShipDate && (
      <ShipDateComponent
        calendarPosition={DropdownMenuPosition.BottomRight}
        displayMessage={messages.shipDate}
        dropdownIconClassName={dropdownIconClassName}
        linkButtonClassName={classnames(style['ship-date'], linkButtonClassName)}
      />
    )
  );
};

export default ShipDate;
